import React from 'react';

export const TypeJson: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.875 13C4.01205 13 3.3125 12.3004 3.3125 11.4375V9.5625C3.3125 9.1481 3.14788 8.75067 2.85485 8.45765C2.56183 8.16462 2.1644 8 1.75 8C2.1644 8 2.56183 7.83538 2.85485 7.54235C3.14788 7.24933 3.3125 6.8519 3.3125 6.4375V4.5625C3.3125 3.69955 4.01205 3 4.875 3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.125 3C11.9879 3 12.6875 3.69955 12.6875 4.5625V6.4375C12.6875 7.30044 13.3871 8 14.25 8C13.3871 8 12.6875 8.69955 12.6875 9.5625V11.4375C12.6875 12.3004 11.9879 13 11.125 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.90625 8.04559C5.90625 8.02833 5.89226 8.01434 5.875 8.01434C5.85774 8.01434 5.84375 8.02833 5.84375 8.04559C5.84375 8.06285 5.85774 8.07684 5.875 8.07684C5.89226 8.07684 5.90625 8.06285 5.90625 8.04559"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.03125 8.04559C8.03125 8.02833 8.01726 8.01434 8 8.01434C7.98274 8.01434 7.96875 8.02833 7.96875 8.04559C7.96875 8.06285 7.98274 8.07684 8 8.07684C8.01726 8.07684 8.03125 8.06285 8.03125 8.04559"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1562 8.04559C10.1562 8.02833 10.1423 8.01434 10.125 8.01434C10.1077 8.01434 10.0937 8.02833 10.0937 8.04559C10.0937 8.06285 10.1077 8.07684 10.125 8.07684C10.1423 8.07684 10.1562 8.06285 10.1562 8.04559"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
